import { Controller } from "@hotwired/stimulus"
import SignaturePad from 'signature_pad'

// Connects to data-controller="signature-pad"
export default class extends Controller {
  static targets = ["wrapper", "clearButton", "canvas", "signatureField"]

  connect() {
    this.signaturePad = new SignaturePad(this.canvasTarget)
    this.delayResizeCanvas()
    this.addEventListeners()
  }

  delayResizeCanvas() {
    setTimeout(() => {
      this.resizeCanvas()
    }, 500)
  }

  addEventListeners() {
    this.clearButtonTarget.addEventListener("click", this.clearCanvas.bind(this))
    this.signaturePad.addEventListener("endStroke", this.endStroke.bind(this))
    window.addEventListener("resize", this.resizeCanvas.bind(this))
  }

  // Resize the canvas based on the device's pixel ratio
  resizeCanvas() {
    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    this.canvasTarget.width = this.canvasTarget.offsetWidth * ratio
    this.canvasTarget.height = this.canvasTarget.offsetHeight * ratio
    this.canvasTarget.getContext("2d").scale(ratio, ratio)
    this.clearCanvas()
  }

  // Clear the canvas
  clearCanvas() {
    this.signaturePad.clear()
    this.clearButtonTarget.classList.add('d-none', 'hidden')
    this.signatureFieldTarget.value = null
  }

  // Handle when the user finishes drawing on the signature pad
  endStroke() {
    this.signatureFieldTarget.value = this.signaturePad.toDataURL("image/svg+xml")
    this.clearButtonTarget.classList.remove('d-none', 'hidden')
  }
}


